import { Menu, IconButton, withStyles } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { useState } from 'react';
import Tooltip from '../StyledToolTip';

const styles = (theme) => ({
  mainMenu: {
    background: theme.gridBGColor,
    borderRadius: '0px 0px 4px 4px',
    marginTop: '30px',
    overflow: 'inherit'
  },
  mainMenuStyle: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 0px',
    width: '220px'
  },
  mainMenuButton: {
    padding: '9px',
    color: theme.HeaderSelectedText
  }
});

const CustomMenu = ({ menuContent, classes }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div>
        <IconButton color="inherit" className={classes.mainMenuButton} onClick={handleOpen}>
          <Tooltip title="Show Controls">
            <MoreVert style={{ fontSize: '21px' }} />
          </Tooltip>
        </IconButton>
      </div>
      <Menu
        disablePortal
        getContentAnchorEl={null}
        disableAutoFocusItem
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={Boolean(anchorEl)}
        keepMounted
        anchorEl={anchorEl}
        onClose={handleClose}
        MenuListProps={{ disablePadding: true }}
        classes={{
          paper: classes.mainMenu
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <div className={classes.mainMenuStyle}>{menuContent}</div>
      </Menu>
    </>
  );
};

export default withStyles(styles)(CustomMenu);
